import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import './BlockchainAdmin/index.scss'
import './BoostXpressAdmin/index.scss'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider, ProtectedAdmin, ProtectedBlockchainAdmin } from './Components'
import PosAccounts from './Pages/Frontend/Components/PosAccounts/PosAccounts'
import PosTransactions from './Pages/Frontend/Components/PosTransactions/PosTransactions'
import ProductLeaseDetails from './Pages/Frontend/Interface/Plp/ProductLease/ProductLeaseDetails'
import {
  Company,
  CompanyProducts,
  Login,
  Logistics,
  Orders,
  Plp,
  ProductDetails,
  ProductScanned,
  Products,
  RequestDetails,
  Requests,
  Settings,
  Transactions,
  Users,
  UsersDetails,
  CompanyLocations,
  CompanyLocationsRates,
  OrderDetails,
  EditOrderDetails,
  PLPDetails,
  PLPTracking,
  DeliveryUltra,
  OrderTracking,
  LogisticsDetails,
  TripDetails,
  OrderLogistics,
  CreatePlp,
  LoanProviders,
  EditUsersDetails,
  CompanyDetails,
  AssignedCustomers,
  LoanProvidersDetails,
  LoanProviderTransaction,
  TransactionDetails,
  LoanProviderPOSTransaction,
  BulkSms,
  BulkSmsHistory,
  CreatePlpv2,
  BulkSmsHistoryDetails,
  LoanProviderAllPOSTransaction,
  ApproveWalletTransfer,
  TGPlusSubscriptionDetails,
  TGPlusSubscription,
  WebsiteControl,
  BankTransferRequestDetails,
  TGPlusReferals,
  TGPlusStations,
  TGPlusStationSubscription,
  TGPlusSolarProvidersStations,
  CityLaunchersDetails,
  CityLaunchers,
  UpdateKYC,
  PaystackStatement,
  UserDetails,
  TGPlusReferalsDetails,
  TGPlusExperienceCenterDetails,
  LeaseAssets,
  TradersCardDetails,
  InvestorsKyc,
  LeaseAssetDetails,
  InvestorsKycDetails,
  AdminManagement,
  AdminDetails,
  AdminRoles,
} from './Pages/Frontend/Interface/Index'

import AdminAccessGuard from './Pages/Frontend/Interface/AdminManagement/Components/AdminAccessGuard'

import PublicWrapper from 'Pages/Skeleton/PublicWrapper/PublicWrapper'
import { Provider } from 'react-redux'
import Store from './Storage/Store'
import { Auth0Provider } from '@auth0/auth0-react'
import { Auth0Config } from './Config/Auth0Config'
import FillingStations from './Pages/Frontend/Interface/FillingStations/FillingStations'
import CreateEditFillingStation from './Pages/Frontend/Interface/FillingStations/CreateEditFillingStation'
import FillingStationDetails from './Pages/Frontend/Interface/FillingStations/FillingStationDetails'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ConditionalRouting } from './ConditionalRouting'
import GeneralOverview from './Pages/Frontend/Interface/Dashboard/GeneralOverview'
import DashboardOverviewV2 from './Pages/Frontend/Interface/Dashboard/DashboardOverviewV2'
import TradeGridOverview from './Pages/Frontend/Interface/Dashboard/TradeGridOverview'
import BoostOverview from './Pages/Frontend/Interface/Dashboard/BoostOverview'
import CashReconciliationDetailPage from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Finance/CashReconciliationDetail'
import TGPlusOverview from './Pages/Frontend/Interface/Dashboard/TGPlusOverview'
import BoostXpressOverview from './Pages/Frontend/Interface/Dashboard/BoostXpressOverview'
import TradersCardOverview from './Pages/Frontend/Interface/Dashboard/TradersCardOverview'
import {
  AnnouncementDetails,
  MarketPrice,
  DepotPrice,
  AverageMarketPrice,
} from './Pages/Frontend/Components'
import TGPlusSubscriptionTransaction from './Pages/Frontend/Interface/TGPlusSubscription/TGPlusSubscriptionDetails/TGPlusSubscriptionTransaction'
import UsersDetailsOld from './Pages/Frontend/Interface/Users/UsersDetails/UsersDetailsOld'
import PosTerminalTransactions from './Pages/Frontend/Components/PosTransactions/PosTerminalTransactions'
import BlockchainAdminWrapper from './BlockchainAdmin/Pages/Skeleton/AdminWrapper/AdminWrapper'
import BlockchainDashboard from './BlockchainAdmin/Pages/Frontend/Interface/Admin/Dashboard/Dashboard'
import BlockchainInvestorsList from './BlockchainAdmin/Pages/Frontend/Interface/Admin/Investors/InvestorsList'
import BlockchainInvestorProfile from './BlockchainAdmin/Pages/Frontend/Interface/Admin/Investors/InvestorProfile'
import BlockchainKycQueue from './BlockchainAdmin/Pages/Frontend/Interface/Admin/KycQueue/KycQueue'
import BlockchainKycReview from './BlockchainAdmin/Pages/Frontend/Interface/Admin/KycQueue/KycReview'
import BlockchainTradersCardList from './BlockchainAdmin/Pages/Frontend/Interface/Admin/TradersCard/TradersCardList'
import BlockchainTradersCardDetails from './BlockchainAdmin/Pages/Frontend/Interface/Admin/TradersCard/TradersCardDetails'
import BlockchainTokenAssetsList from './BlockchainAdmin/Pages/Frontend/Interface/Admin/TokenAssets/TokenAssetsList'
import BlockchainTokenAssetDetails from './BlockchainAdmin/Pages/Frontend/Interface/Admin/TokenAssets/TokenAssetDetails'
import BlockchainPoolState from './BlockchainAdmin/Pages/Frontend/Interface/Admin/PoolState/PoolState'
import BlockchainNotifications from './BlockchainAdmin/Pages/Frontend/Interface/Admin/Notifications/Notifications'

import BoostXpressAdminWrapper from './BoostXpressAdmin/Pages/Skeleton/AdminWrapper/AdminWrapper'
import BoostXpressDashboard from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Dashboard/Dashboard'
import BoostXpressAttendants from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Attendants/Attendants'
import BoostXpressAttendantDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Attendants/AttendantDetails'
import BoostXpressUsersList from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Users/UsersList'
import BoostXpressUserDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Users/UserDetails'
import BoostXpressStationsList from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Stations/StationsList'
import BoostXpressAddStation from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Stations/AddStation'
import BoostXpressEditStation from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Stations/EditStation'
import BoostXpressStationDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Stations/StationDetails'
import BoostXpressTransactionsList from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Transactions/TransactionsList'
import BoostXpressTransactionDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Transactions/TransactionDetails'
import BoostXpressVouchersList from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Vouchers/VouchersList'
import BoostXpressPayouts from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Payouts/Payouts'
import BoostXpressPayoutDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Payouts/PayoutDetails'
import BoostXpressFinance from './Pages/Frontend/Interface/Finance/Finance'
import PushNotification from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/PushNotification/PushNotification'
import BoostXpressPriceMatchList from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/PriceMatch/PriceMatchList'
import BoostXpressPriceMatchDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/PriceMatch/PriceMatchDetails'
import Referrals from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Referals/Referrals'
import ProtectedBoostXpressAdmin from './Components/ProtectedBoostXpressAdmin/ProtectedBoostXpressAdmin'
import BxPosTerminalTransactions from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Stations/BxPosTerminalTransactions'
import OrderBoost from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Order/OrderBoost'
import OrderBoostDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Order/OrderBoostDetails'
import BoostXpressOrderDisputes from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/OrderDisputes/OrderDisputes'
import BNPMReferralsDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Referals/BNPMReferralsDetails'
import ReferralsDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/Referals/ReferralsDetails'
import AppConfig from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/AppConfig/AppConfig'
import BoostCredit from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/BoostCredit/BoostCredit'
import BoostCreditFacilityDetails from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/BoostCredit/BoostCreditFacilityDetails'
import BoostPromoStations from './BoostXpressAdmin/Pages/Frontend/Interface/Admin/BoostPromoStations/BoostPromoStations'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 1000,
    },
  },
})

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <BrowserRouter>
          <HelmetProvider>
            <Auth0Provider
              domain={Auth0Config.domain}
              clientId={Auth0Config.clientId}
              authorizationParams={Auth0Config.authorizationParams}
            >
              <AuthProvider>
                <Routes>
                  <Route path='login' element={<Login />} />

                  <Route path='' element={<ProtectedAdmin></ProtectedAdmin>}>
                    <Route index element={<ConditionalRouting></ConditionalRouting>} />
                    <Route path='dashboard' element={<ConditionalRouting></ConditionalRouting>} />
                    <Route path='general-overview-v2' element={<DashboardOverviewV2 />} />
                    <Route path='general-overview' element={<GeneralOverview />} />
                    <Route
                      path='general-overview/tradegrid-overview'
                      element={<TradeGridOverview />}
                    />
                    <Route path='finance' element={<BoostXpressFinance />} />
                    <Route path='finance/cash-reconciliation/:submissionId' element={<CashReconciliationDetailPage />} />

                    <Route path='general-overview/boost-overview' element={<BoostOverview />} />
                    <Route
                      path='general-overview/boostxpress-overview'
                      element={<BoostXpressOverview />}
                    />

                    <Route
                      path='general-overview/traderscard-overview'
                      element={<TradersCardOverview />}
                    />
                    <Route path='company' element={<Company />} />
                    <Route path='company/products/:companyUuid' element={<CompanyProducts />} />
                    <Route path='company/locations/:companyUuid' element={<CompanyLocations />} />
                    <Route
                      path='company/locations/rates/:locationUuid'
                      element={<CompanyLocationsRates />}
                    />
                    <Route path='company/details/:uuid' element={<CompanyDetails />} />

                    <Route path='products' element={<Products />} />
                    <Route path='product/:productId' element={<ProductDetails />} />

                    <Route path='orders' element={<Orders />} />
                    <Route path='order/:referenceId' element={<OrderDetails />} />

                    <Route path='order-tracking/:referenceId' element={<OrderTracking />} />
                    <Route path='order-logistics/:referenceId' element={<OrderLogistics />} />

                    <Route path='order/edit/:referenceId' element={<EditOrderDetails />} />

                    <Route path='requests' element={<Requests />} />
                    <Route path='request/:referenceId' element={<RequestDetails />} />
                    <Route
                      path='bank-transfer-request/:referenceId'
                      element={<BankTransferRequestDetails />}
                    />
                    <Route path='plp' element={<Plp />} />
                    <Route path='plp/:referenceId' element={<PLPTracking />} />
                    <Route path='plp/detail/:referenceId' element={<PLPDetails />} />
                    <Route path='plp/create' element={<CreatePlp />} />
                    <Route path='product-leases/:uuid' element={<ProductLeaseDetails />} />

                    <Route path='traders-card/:referenceId' element={<TradersCardDetails />} />

                    <Route path='transactions' element={<Transactions />} />
                    <Route path='transactions/:uuid' element={<TransactionDetails />} />
                    <Route path='pos-accounts/:terminalId' element={<PosAccounts />} />
                    <Route path='pos-transactions/:terminalId' element={<PosTransactions />} />

                    <Route
                      path='pos-terminal-transactions/:terminalId'
                      element={<PosTerminalTransactions />}
                    />

                    <Route path='settings' element={<Settings />} />

                    <Route
                      path='admin-management'
                      element={
                        <AdminAccessGuard>
                          <AdminManagement />
                        </AdminAccessGuard>
                      }
                    />
                    <Route
                      path='admin-management/roles'
                      element={
                        <AdminAccessGuard requireSuperAdmin>
                          <AdminRoles />
                        </AdminAccessGuard>
                      }
                    />
                    <Route
                      path='admin-management/:id'
                      element={
                        <AdminAccessGuard>
                          <AdminDetails />
                        </AdminAccessGuard>
                      }
                    />

                    <Route path='web-control' element={<WebsiteControl />}>
                      <Route path='announcement' element={<AnnouncementDetails />} />
                      <Route path='average-market-price' element={<AverageMarketPrice />} />
                      <Route path='market-price' element={<MarketPrice />} />
                      <Route path='depot-price' element={<DepotPrice />} />
                    </Route>

                    <Route path='tgplus-subscription' element={<TGPlusSubscription />} />

                    <Route
                      path='tgplus-subscription/:subscriptionId'
                      element={<TGPlusSubscriptionDetails />}
                    />

                    <Route
                      path='tgplus-subscription/:subscriptionId/transaction'
                      element={<TGPlusSubscriptionTransaction />}
                    />

                    <Route path='tgplus-stations/:customerMsisdn' element={<TGPlusStations />} />

                    <Route
                      path='tgplus-stations-subscription/:customerMsisdn'
                      element={<TGPlusStationSubscription />}
                    />

                    <Route
                      path='tgplus-subscription/referals/:id'
                      element={<TGPlusReferalsDetails />}
                    />

                    <Route
                      path='tgplus-subscription/experience-center/:id'
                      element={<TGPlusExperienceCenterDetails />}
                    />

                    <Route
                      path='solar-providers-stations/:customerMsisdn/:businessName/:balance/:solarProviderAccountId'
                      element={<TGPlusSolarProvidersStations />}
                    />

                    <Route path='city-launchers' element={<CityLaunchers />} />

                    <Route
                      path='city-launchers/:customerMsisdn'
                      element={<CityLaunchersDetails />}
                    />

                    <Route path='tgplus-referals/:userUuid' element={<TGPlusReferals />} />

                    <Route path='logistics' element={<Logistics />} />
                    <Route path='logistic/:truckId' element={<LogisticsDetails />} />
                    <Route path='logistic/truck/details/:referenceId' element={<TripDetails />} />

                    <Route path='users' element={<Users />} />
                    <Route path='user/:customerAccountId' element={<UsersDetailsOld />} />
                    <Route path='user-new/:customerAccountId' element={<UserDetails />} />
                    <Route path='user/edit/:customerAccountId' element={<EditUsersDetails />} />
                    <Route path='user/kyc/:customerAccountId' element={<UpdateKYC />} />

                    <Route path='product-scanner' element={<ProductScanned />} />

                    <Route path='ultra-delivery' element={<DeliveryUltra />} />

                    <Route path='loan-providers' element={<LoanProviders />} />
                    <Route path='loan-providers/:loanProvider' element={<LoanProvidersDetails />} />
                    <Route
                      path='loan-providers/users/:loanProvider'
                      element={<AssignedCustomers />}
                    />
                    <Route
                      path='loan-providers/users/post-transaction/:loanProvider/:customerAccountId/:accountNumber'
                      element={<LoanProviderPOSTransaction />}
                    />
                    <Route
                      path='loan-providers/users/post-transaction/:loanProvider'
                      element={<LoanProviderAllPOSTransaction />}
                    />

                    <Route
                      path='loan-providers/transaction/:loanProvider'
                      element={<LoanProviderTransaction />}
                    />
                    <Route path='bulksms' element={<BulkSms />} />
                    <Route path='bulksms-history' element={<BulkSmsHistory />} />
                    <Route path='bulksms-history/:smsId' element={<BulkSmsHistoryDetails />} />

                    <Route
                      path='/transfer-approval/:loanProvider/:transferRequestId'
                      element={<ApproveWalletTransfer />}
                    />

                    <Route path='/paystack-statement' element={<PaystackStatement />} />

                    <Route path='/lease-assets' element={<LeaseAssets></LeaseAssets>} />
                    <Route
                      path='/lease-assets/details/:id'
                      element={<LeaseAssetDetails></LeaseAssetDetails>}
                    />

                    <Route path='/investors-kyc' element={<InvestorsKyc></InvestorsKyc>} />
                    <Route
                      path='/investors-kyc/:id'
                      element={<InvestorsKycDetails></InvestorsKycDetails>}
                    />

                    <Route path='/filling-stations' element={<FillingStations />} />
                    <Route path='/filling-stations/create' element={<CreateEditFillingStation />} />
                    <Route
                      path='/filling-stations/edit/:id'
                      element={<CreateEditFillingStation />}
                    />
                    <Route path='/filling-stations/:id' element={<FillingStationDetails />} />
                  </Route>

                  <Route path='blockchain' element={<ProtectedBlockchainAdmin />}>
                    <Route element={<BlockchainAdminWrapper />}>
                      <Route index element={<Navigate to='dashboard' replace />} />
                      <Route path='dashboard' element={<BlockchainDashboard />} />
                      <Route path='investors' element={<Navigate to='all' replace />} />
                      <Route path='investors/:filter' element={<BlockchainInvestorsList />} />
                      <Route
                        path='investors/:filter/:investorId'
                        element={<BlockchainInvestorProfile />}
                      />
                      <Route path='kyc-queue' element={<Navigate to='all' replace />} />
                      <Route path='kyc-queue/:status' element={<BlockchainKycQueue />} />
                      <Route
                        path='kyc-queue/:status/:applicantId'
                        element={<BlockchainKycReview />}
                      />
                      <Route path='traders-card' element={<Navigate to='ALL' replace />} />
                      <Route path='traders-card/:status' element={<BlockchainTradersCardList />} />
                      <Route
                        path='traders-card/:status/:applicationId'
                        element={<BlockchainTradersCardDetails />}
                      />
                      <Route path='token-assets' element={<Navigate to='ALL' replace />} />
                      <Route path='token-assets/:status' element={<BlockchainTokenAssetsList />} />
                      <Route
                        path='token-assets/:status/:tokenAssetId'
                        element={<BlockchainTokenAssetDetails />}
                      />
                      <Route path='pool-state' element={<Navigate to='assigned' replace />} />
                      <Route path='pool-state/:tab' element={<BlockchainPoolState />} />
                      <Route path='*' element={<Navigate to='/blockchain/dashboard' replace />} />
                    </Route>
                  </Route>

                  <Route path='boostxpress' element={<ProtectedBoostXpressAdmin />}>
                    <Route element={<BoostXpressAdminWrapper />}>
                      <Route index element={<Navigate to='dashboard' replace />} />
                      <Route path='dashboard' element={<BoostXpressDashboard />} />
                      <Route path='attendants' element={<BoostXpressAttendants />} />
                      <Route path='attendants/:id' element={<BoostXpressAttendantDetails />} />
                      <Route path='payouts' element={<BoostXpressPayouts />} />
                      <Route path='payouts/:id' element={<BoostXpressPayoutDetails />} />
                      <Route path='users' element={<BoostXpressUsersList />} />
                      <Route path='users/:id' element={<BoostXpressUserDetails />} />
                      <Route path='stations' element={<BoostXpressStationsList />} />
                      <Route path='stations/new' element={<BoostXpressAddStation />} />
                      <Route path='stations/:id' element={<BoostXpressStationDetails />} />
                      <Route path='stations/:id/edit' element={<BoostXpressEditStation />} />
                      <Route path='transactions' element={<BoostXpressTransactionsList />} />
                      <Route path='transactions/:id' element={<BoostXpressTransactionDetails />} />
                      <Route path='vouchers' element={<BoostXpressVouchersList />} />
                      <Route path='price-match' element={<BoostXpressPriceMatchList />} />
                      <Route
                        path='price-match/:submissionId'
                        element={<BoostXpressPriceMatchDetails />}
                      />
                      <Route path='notifications' element={<PushNotification />} />
                      <Route path='referrals' element={<Referrals />} />
                      <Route path='referrals/:id' element={<ReferralsDetails />} />
                      <Route path='bnpm-referrals/:id' element={<BNPMReferralsDetails />} />
                      <Route path='boost-flex' element={<BoostCredit />} />
                      <Route path='boost-credit/facility/:facilityId' element={<BoostCreditFacilityDetails />} />
                      <Route path='boost-promo-stations' element={<BoostPromoStations />} />
                      <Route path='app-config' element={<AppConfig />} />

                      <Route
                        path='bx-pos-terminal-transactions/:terminalId'
                        element={<BxPosTerminalTransactions />}
                      />

                      <Route path='orders' element={<OrderBoost />} />

                      <Route path='orders/:orderId' element={<OrderBoostDetails />} />

                      <Route path='order-disputes' element={<BoostXpressOrderDisputes />} />

                      <Route path='*' element={<Navigate to='/boostxpress/dashboard' replace />} />
                    </Route>
                  </Route>

                  <Route
                    path='plp-application'
                    element={
                      <PublicWrapper external={false}>
                        <CreatePlp publicAccess={true} />
                      </PublicWrapper>
                    }
                  />
                  <Route
                    path='plp-application-vfd'
                    element={
                      <PublicWrapper external={true}>
                        <CreatePlpv2 publicAccess={true} />
                      </PublicWrapper>
                    }
                  />
                </Routes>
              </AuthProvider>
            </Auth0Provider>
          </HelmetProvider>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
)
